import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { routes } from '../config';
import Login from '../pages/Login';
import OTP from '../pages/OTP';
import {FirebaseUser} from "@/types";

interface ExtendedAppRoutesProps {
  firebaseUser: FirebaseUser | null;
}

function AppRoutesContent({
}: ExtendedAppRoutesProps) {
  return (
    <Box sx={{ height: '100svh' }}>
      <Routes>
        <Route
          path={routes.login}
          element={
            <Login />
          }
        />
        <Route
          path={routes.otp}
          element={
            <OTP />
          }
        />

      </Routes>
    </Box>
  );
}

export default function AppRoutes(props: ExtendedAppRoutesProps) {
  return <AppRoutesContent {...props} />;
} 